import PersonIcon from '@mui/icons-material/Person';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';
import { AuthenticationState } from '../../@types/AuthenticationState';
import MenuItemText from '../MenuItemText';

interface UserPanelButtonProps {
    authenticationState: AuthenticationState | null;
    menuOpenHandler: (event: React.SyntheticEvent<EventTarget>) => void;
}

const UserPanelButton: FC<UserPanelButtonProps> = ({ authenticationState, menuOpenHandler }) => {
    const theme = useTheme();

    return (
        <>
            {
                (authenticationState && authenticationState.isAuthenticated)
                    ? <><Button
                        variant='text'
                        onClick={menuOpenHandler}
                        sx={{
                            color: 'white',
                            textTransform: 'none',
                            mr: 2,
                            borderRight: 1,
                            borderColor: 'rgba(255, 255, 255, 0.3)',
                            borderRadius: 0,
                            pr: 2,
                            display: 'flex',
                            alignItems: 'center',
                            gap: { xs: 0, md: 1 }, // No gap on mobile, normal gap on desktop
                            minWidth: { xs: 'auto', md: 'auto' }, // Compact on mobile
                            px: { xs: 1, md: 2 } // Less horizontal padding on mobile
                        }}
                    >
                        <PersonIcon sx={{ color: theme.palette.text.navbar }} />
                        <MenuItemText
                            sx={{
                                display: { xs: 'none', md: 'block' } // Hide name on mobile, show on desktop
                            }}
                        >
                            {authenticationState.identity.firstName} {authenticationState.identity.lastName}
                        </MenuItemText>
                    </Button></>
                    : <></>
            }
        </>

    )

};
export default UserPanelButton
